import * as React from 'react';
import { connect } from 'react-redux';

import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';

import {
  toggleAgreeToCreateNewCollection
} from 'modules/create-new-profiles/reducers/actions';

import { __t, applyTranslations } from 'utils/language';

import { State } from 'types';

import './create-new-profiles-for-smart-collection-confirmation-modal.scss';

applyTranslations(
  require('./create-new-profiles-for-smart-collection-confirmation-modal.i18n.json')
);

interface StateProps {
  wantToCreateNew: boolean
}

interface DispatchProps {
  dispatchToggleAgreeToCreateNewCollection: (v: boolean) => void
}

type Props = StateProps & DispatchProps;

const CreateNewProfilesForSmartCollectionConfirmationModal = ({
  wantToCreateNew,
  dispatchToggleAgreeToCreateNewCollection
}: Props): JSX.Element => (
  <div className="create-new-profiles-for-smart-collection-confirmation-modal">
    <div className="create-new-profiles-for-smart-collection-confirmation-modal__text">
      {__t('create_new_profiles_for_smart_collection_confirmation_modal.text')}
    </div>
    <div className="create-new-profiles-for-smart-collection-confirmation-modal__checkbox">
      <InputCheckbox
        size="small"
        name="new-collection"
        id="create_new_profiles_for_smart_collection_confirmation_modal/create-new-collection"
        label={__t('create_new_profiles_for_smart_collection_confirmation_modal.checkbox')}
        checked={wantToCreateNew}
        onChange={event => dispatchToggleAgreeToCreateNewCollection(event.target.checked)}
      />
    </div>
  </div>
);

export const mapStateToProps = ({ createNewProfiles }: State): StateProps => ({
  wantToCreateNew: createNewProfiles.confirmationModal?.wantToCreateNew ?? false
});

export const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchToggleAgreeToCreateNewCollection: value => dispatch(
    toggleAgreeToCreateNewCollection(value)
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateNewProfilesForSmartCollectionConfirmationModal);
